<script>
// NavBar组件
import { pageSortRender } from "../../minin/homepage.js"; // 导入单独的函数
import { mapState } from "vuex";

export default {
  // 不混入pageComponent
  data() {
    return {
      navList: [],
      activeIndex: 0,
      childConfigs: [],
      isFlow: false,
      scrollType: "scrollLeft",
      canScrollLeft: false,
      canScrollRight: false
    };
  },
  computed: {
    ...mapState("user", {
      userInfo: state => {
        return state.userInfo;
      }
    })
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    modelName: {
      type: String,
      default: ""
    },
    // 主题颜色属性
    themeColor: {
      type: String,
      default: "#3498db"
    },
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    list: {
      handler(newV, oldV) {
        this.$set(this, "navList", newV || []);

        console.log("navList:", this.navList);

        if (newV && newV.length > 0) {
          this.childConfigs = newV[0].children || [];
        }
        this.$nextTick(() => {
          this.checkScrollability();
          this.$bus.$emit("resetLeftNav");
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeNav(index, item) {
      this.activeIndex = index;
      const list = item.children || [];
      this.childConfigs = list.map(e => {
        e.parentName = this.modelName;
        return e;
      });
      this.$emit("change", { index, item });
    },
    navIsOver() {
      if (!this.$refs.navWrapper || !this.$refs.navBar) return;

      const wrapperWidth = this.$refs.navWrapper.clientWidth;
      const navBarWidth = this.$refs.navBar.scrollWidth;

      this.isFlow = navBarWidth > wrapperWidth;
      this.checkScrollability();
    },
    checkScrollability() {
      if (!this.$refs.navBar) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.$refs.navBar;
      this.canScrollLeft = scrollLeft > 0;
      this.canScrollRight = scrollLeft < scrollWidth - clientWidth - 1;
    },
    scrollFun(direction) {
      if (!this.$refs.navBar) return;

      const scrollAmount = 200;
      const currentScroll = this.$refs.navBar.scrollLeft;
      const maxScroll = this.$refs.navBar.scrollWidth - this.$refs.navBar.clientWidth;

      if (direction === "scrollLeft") {
        if (currentScroll <= 0) return;
        this.$refs.navBar.scrollTo({
          left: Math.max(0, currentScroll - scrollAmount),
          behavior: "smooth"
        });
      } else {
        if (currentScroll >= maxScroll) return;
        this.$refs.navBar.scrollTo({
          left: Math.min(maxScroll, currentScroll + scrollAmount),
          behavior: "smooth"
        });
      }

      this.scrollType = direction;

      // 更新滚动状态
      setTimeout(() => {
        this.checkScrollability();
      }, 300);
    }
  },
  mounted() {
    this.navIsOver();
    window.addEventListener("resize", this.navIsOver);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.navIsOver);
  },
  render(h) {
    return (
      <div>
        <div id={"new-navbar-id-" + this.id}></div>
        <div class="config-nav-name" data-type="navbar" data-id={this.id} style="display:none">
          导航
        </div>
        <div class="nav-container">
          {this.isFlow
            ? [
                <div
                  class={{
                    "scroll-btn toLeft": true,
                    disabled: !this.canScrollLeft
                  }}
                  key="toLeft"
                  on-click={() => this.scrollFun("scrollLeft")}
                >
                  <div class="scroll-btn-inner">
                    <i class="fas fa-chevron-left"></i>
                  </div>
                </div>,
                <div
                  class={{
                    "scroll-btn toRight": true,
                    disabled: !this.canScrollRight
                  }}
                  key="toRight"
                  on-click={() => this.scrollFun("scrollRight")}
                >
                  <div class="scroll-btn-inner">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              ]
            : null}
          <div ref="navWrapper" class="nav-wrapper">
            <div
              ref="navBar"
              class={{ "nav-bar": true, "flex-col-center": !this.isFlow }}
              on-scroll={this.checkScrollability}
            >
              {this.navList.map((item, index) => (
                <div
                  class={{
                    "nav-item": true,
                    active: index === this.activeIndex
                  }}
                  key={item.id}
                  on-click={() => this.changeNav(index, item)}
                >
                  <div class="nav-item-content">
                    <span class="nav-text">{item.name}</span>
                  </div>
                  <div class="nav-indicator"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div class="nav-content">{pageSortRender(h, this.childConfigs, this.userInfo)}</div>
      </div>
    );
  }
};
</script>

<style lang="scss" scoped>
.nav-container {
  margin: 0 auto;
  margin-bottom: 20px;
  width: calc(100% - 100px);
  // background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-light60) 100%);
  background: var(--color-primary);
  border-radius: 2px;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0 50px;
  position: relative;

  &:hover {
    .scroll-btn {
      opacity: 1;
      transform: translateY(-50%) scale(1);
    }
  }
}

/* 美化后的滚动按钮样式 */
.scroll-btn {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%) scale(0.9);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  opacity: 0;
  z-index: 100;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8);

  /* 玻璃态效果 */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  &:hover {
    transform: translateY(-50%) scale(1.1);
    background: linear-gradient(135deg, #ffffff 0%, #e9ecef 100%);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);

    .scroll-btn-inner {
      color: var(--color-primary);
      transform: scale(1.1);
    }
  }

  &:active {
    transform: translateY(-50%) scale(1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
  }

  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;

    &:hover {
      transform: translateY(-50%) scale(0.9);
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1);

      .scroll-btn-inner {
        color: #6c757d;
        transform: scale(1);
      }
    }
  }
}

.scroll-btn-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #495057;
  font-size: 14px;
  transition: all 0.3s ease;
  border-radius: 50%;
}

.toLeft {
  left: 12px;

  &:not(.disabled):hover {
    .scroll-btn-inner {
      transform: translateX(-1px) scale(1.1);
    }
  }
}

.toRight {
  right: 12px;

  &:not(.disabled):hover {
    .scroll-btn-inner {
      transform: translateX(1px) scale(1.1);
    }
  }
}

/* 添加脉冲动画效果 */
@keyframes pulse-glow {
  0% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1),
      0 0 0 3px rgba(var(--color-primary-rgb), 0.2);
  }
  100% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1);
  }
}

.scroll-btn:not(.disabled) {
  animation: pulse-glow 2s infinite;
}

.nav-wrapper {
  width: 100%;
  position: relative;
  height: 56px;
  overflow: hidden;
}

.nav-bar {
  display: flex;
  align-items: center;
  height: 100%;
  transition: all 0.3s ease;
  overflow-x: auto;
  scroll-behavior: smooth;

  /* 隐藏滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.nav-item {
  height: 100%;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  padding: 0 16px;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.15);

    .nav-text {
      transform: translateY(-1px);
    }
  }

  &.active {
    .nav-item-content {
      .nav-text {
        font-weight: 700;
        transform: translateY(-1px);
      }
    }

    .nav-indicator {
      opacity: 1;
      transform: translateX(-50%) scaleX(1);
    }
  }
}

.nav-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.nav-text {
  font-size: 15px;
  color: #fff;
  font-weight: 600;
  transition: all 0.3s ease;
  white-space: nowrap;
  letter-spacing: 0.3px;
}

.nav-indicator {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%) scaleX(-1);
  width: 60%;
  height: 3px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 2px;
  opacity: 0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.nav-content {
  margin-top: 16px;
  transition: all 0.3s ease;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .nav-container {
    width: 95%;
    padding: 0 40px;
  }

  .nav-bar {
    height: 52px;
  }

  .nav-item {
    min-width: 140px;
    padding: 0 12px;
  }

  .nav-text {
    font-size: 14px;
  }

  .scroll-btn {
    width: 36px;
    height: 36px;
  }
}

@media (max-width: 768px) {
  .nav-container {
    padding: 0 30px;
  }

  .nav-bar {
    height: 48px;
  }

  .nav-item {
    min-width: 120px;
    padding: 0 10px;
  }

  .nav-text {
    font-size: 13px;
  }

  .scroll-btn {
    width: 32px;
    height: 32px;

    &.toLeft {
      left: 8px;
    }

    &.toRight {
      right: 8px;
    }
  }

  .scroll-btn-inner {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .nav-container {
    padding: 0 20px;
  }

  .nav-bar {
    height: 44px;
  }

  .nav-item {
    min-width: 100px;
    padding: 0 8px;
  }

  .nav-item-content {
    gap: 6px;
  }

  .nav-text {
    font-size: 12px;
  }

  .scroll-btn {
    display: none; /* 在非常小的屏幕上隐藏按钮 */
  }
}

/* 动画效果 */
@keyframes navItemFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.nav-item {
  animation: navItemFadeIn 0.4s ease forwards;

  // 支持更多标签的动画延迟
  @for $i from 1 through 20 {
    &:nth-child(#{$i}) {
      animation-delay: #{$i * 0.05}s;
    }
  }
}

/* 深色主题适配 */
@media (prefers-color-scheme: dark) {
  .scroll-btn {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05);

    .scroll-btn-inner {
      color: rgba(255, 255, 255, 0.8);
    }

    &:hover {
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.1) 100%);

      .scroll-btn-inner {
        color: white;
      }
    }
  }
}
</style>
